
// import { restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client'
import { AUTH_TOKEN_LOCALSTORAGE_KEY } from './vue-apollo'

// Manually call this when user log in
export async function onLogin (apolloClient, token) {
  if (typeof localStorage !== 'undefined' && token) {
    localStorage.setItem(AUTH_TOKEN_LOCALSTORAGE_KEY, token)
  }
  // if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
  try {
    await apolloClient.cache.reset()
    await apolloClient.stop()
    await apolloClient.resetStore()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (login)', 'color: orange;', e.message)
  }
}

// Manually call this when user log out
export async function onLogout (apolloClient) {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(AUTH_TOKEN_LOCALSTORAGE_KEY)
  }
  // if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
  try {
    await apolloClient.cache.reset()
    await apolloClient.stop()
    await apolloClient.clearStore()
    await apolloClient.resetStore()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (logout)', 'color: orange;', e.message)
  }
}

export async function setStoreType (storeType) {
  localStorage.setItem('storeType', storeType)
}

export async function getStoreType () {
    return localStorage.getItem('storeType') || 'container'
}
